import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import NavigationBar from '../core/widgets/ui/NavigationBar';

import LayoutHome from '../layouts/LayoutHome';
import LayoutTicket from '../layouts/LayoutTicket';
import LayoutStaff from '../layouts/LayoutStaff';
import LayoutSetting from '../layouts/LayoutSetting';

export default function PageHome() {

    const { page } = useParams();

    return (
        <div className='w-full h-screen overflow-hidden flex'>
            <NavigationBar />
            {(() => {
                switch (page) {
                    case 'overview':
                    case 'main':
                        return (<LayoutHome />);
                    case 'ticket':
                        return (<LayoutTicket />);
                    case 'staff':
                    case 'staffAdd':
                    case 'staffInfo':
                        return (<LayoutStaff />);
                    case 'setting':
                    case 'marDept':
                    case 'pageStyle':
                        return (<LayoutSetting />);
                    default:
                        return (
                            <div className="w-full h-full text-5xl flex items-center justify-center" style={{ height: "80vh" }}>
                                No Data Found
                            </div>
                        );
                }
            })()}
        </div>
    )
}
